export default __webpack_public_path__ + "images/G7.27b6cba.png";